const initialState = {
  loading: false,
  variant: "dots"
};

export default function loaderReducer(state = initialState, action) {
  switch (action.type) {
    case "SHOW_LOADER":
      return { ...state, loading: true, variant: action.payload?.variant || "dots" };
    case "HIDE_LOADER":
      return { ...state, loading: false };
    default:
      return state;
  }
}
